import type { Tag } from "../lib/types";

interface TagChipProps {
  tag: Tag;
}

// Solid, read-only tag chip used to display a tag in record and recurring-payment rows.
export function TagChip({ tag }: TagChipProps) {
  return (
    <span className="record-tag" style={{ backgroundColor: tag.color, borderColor: tag.color }}>
      {tag.name}
    </span>
  );
}
